import { render, staticRenderFns } from "./detailLogo.vue?vue&type=template&id=8336910c&scoped=true&"
import script from "./detailLogo.vue?vue&type=script&lang=js&"
export * from "./detailLogo.vue?vue&type=script&lang=js&"
import style0 from "./detailLogo.vue?vue&type=style&index=0&id=8336910c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8336910c",
  null
  
)

export default component.exports